<button mat-icon-button class="mat-focus-indicator mat-icon-button mat-button-base" [matMenuTriggerFor]="helpMenu">
  <mat-icon class="mat-icon notranslate mat-icon-no-color cursor material-icons-outlined">help_outline</mat-icon>
</button>
<mat-menu #helpMenu yPosition="above">
  <a mat-menu-item [href]="'sideNav.helpcenter.help_link' | translate" target="_blank">
    <mat-icon class="material-icons-outlined">help</mat-icon>
    {{ 'sideNav.helpmenu.help' | translate }}
  </a>
  <a mat-menu-item href="mailto:{{ supportMail }}">
    <mat-icon class="material-icons-outlined">mail</mat-icon>
    {{ 'sideNav.helpmenu.contact' | translate }}
  </a>
  <a mat-menu-item href="{{ 'sideNav.helpmenu.privacypolicylink' | translate }}" target="_blank">
    <mat-icon class="material-icons-outlined">policy</mat-icon>
    {{ 'sideNav.helpmenu.privacypolicy' | translate }}
  </a>
  <button mat-menu-item (click)="showConsentManagement()">
    <mat-icon class="material-icons-outlined">beenhere</mat-icon>
    {{ 'sideNav.helpmenu.consentManagement' | translate }}
  </button>
</mat-menu>
